import { useDispatch, useSelector } from "react-redux"
import MobileComponent from "./datatable/mobile"
import DesktopComponent from "./datatable/desktop"
import useIsMobile from "../../../hook/useIsMobile"
import { useEffect, useState } from "react"
import { orderActions } from "../../../store/orders-slice"
import { useLocation, useParams } from "react-router-dom"
import OrderDetails from "./orderdetails"
import Skeleton from "react-loading-skeleton"
import useFetch from './../../../hook/useFetch';
import { userActions } from "../../../store/user-slice"


export default function Orders() {

    let dispatch = useDispatch()

    const { id } = useParams();

    const [orders, setOrders] = useState()

    const { get } = useFetch()
    

    let location = useLocation()
    const fetchOrders = () => {
        setOrders(null)
        dispatch(orderActions.resetOrders())
        get(`/orders`, null, null, (data) => {
            setOrders(data)
            dispatch(orderActions.setOrders(data))
            dispatch(userActions.setOrders(data))
        })
    }
    useEffect(() => {

        fetchOrders()
    }, [])

    useEffect(() => {
        if (location.state && location.state.refetch) {

            fetchOrders()
        }
    }, [location.state])

    const { isMobile } = useIsMobile()

    if (!orders) {
        return <Skeleton count={50} />
    }

    if (id) {
        return <OrderDetails id={id} />
    }

    return <div className="rso-pages card shadow  bg-white rounded p-3 m-0">{isMobile ? <MobileComponent /> : <DesktopComponent />}</div>
}